import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgV2BoldPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	"xmlns:svgjs": "http://svgjs.com/svgjs",
	viewBox: "0 0 16 16",
	width: 16,
	height: 16,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "matrix(0.6666666666666666,0,0,0.6666666666666666,0,0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z",
			fill: "currentColor",
			stroke: "none",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 0
		})
	})
});
export default SvgV2BoldPlus;
